import React from 'react'
import { StyleSheet, View } from 'react-native'
import { ApplicationProvider as KittenProvider } from '@ui-kitten/components'
import * as eva from '@eva-design/eva'
import { Button, Text } from '@components/base'
import { getTheme, ThemeName } from '@src/style'

interface BugsnagRootErrorFallbackProps {
  clearError: () => void
}

export const BugsnagRootErrorFallback = ({ clearError }: BugsnagRootErrorFallbackProps) => {
  return (
    <KittenProvider {...eva} theme={getTheme(ThemeName.Light)}>
      <View style={styles.container}>
        <View style={styles.content}>
          <Text type="title-2" style={styles.title}>
            Something went wrong
          </Text>
          <Text type="regular" style={styles.description}>
            The app hit an unexpected issue. Reload to continue.
          </Text>
          <Button
            type="primary"
            size="block"
            style={styles.button}
            accessibilityLabel="Reload app"
            onPress={clearError}
          >
            Reload app
          </Button>
        </View>
      </View>
    </KittenProvider>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
  },
  content: {
    width: '100%',
    maxWidth: 360,
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
    color: '#111111',
  },
  description: {
    marginTop: 12,
    fontSize: 16,
    lineHeight: 24,
    color: '#4b5563',
  },
  button: {
    marginTop: 24,
  },
})
